import UploadFileDialog from './UploadFileDialog';

export default UploadFileDialog;
